import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { NavLink, withRouter } from 'react-router-dom';

import ReactTooltip from 'react-tooltip';

import logo from '../../assets/images/logos/Logo-Color@2x.png';
import logoMobile from '../../assets/images/logos/Icon@2x.png';

import {
  appConfig,
  isProduction,
  currentUserRole,
  isAssessmentRoute,
  localizeToString,
} from '../../util';

import { getIcon, getCountryIcon } from '../../util/icons';

import {
  ChangeLocalizationModal
} from '../modals';

class Header extends Component {

  state = {
    changingLocalization: false
  }

  showAssessmentHeader(){
    return isAssessmentRoute(this.props.route);
  }

  showMinimalHeader(){
    const userRole = currentUserRole();
    return userRole !== 'manager' && userRole !== 'admin' && userRole !== 'salesleader' && userRole !== 'superadmin' && userRole !== '';
  }

  renderLanguageSelectButton(){
    return (
      <React.Fragment>
        <li onClick={() => { this.setState({ changingLocalization: true }); }} className="language-dropdown" data-for="header-icon-language-select" data-tip="Change Language">
          <div><span className="country-icon">{getCountryIcon(this.props.activeLocalizationKey)}</span><span className="chevron">{getIcon('chevron-down')}</span></div>
        </li>
        <ReactTooltip id="header-icon-language-select" effect="solid" place="bottom" />
      </React.Fragment>
    );
  }

  renderAssessmentNavigation(){

    if(!this.props.user){
      return null;
    }

    const userIsOrganizationMember = this.props.user.organizationId;

    const hasScoredAssessment = _.find(this.props.myAssessments, {status: 'scored'}) ? true : false;

    const currentAssessmentConfig = this.props.user.currentAssessmentConfig;

    if(!currentAssessmentConfig){
      return null;
    }

    const localizations = {
      viewResults: localizeToString(this.props.activeLocalization, 'btn_view_results', 'View Results'),
      continueAssessment: localizeToString(this.props.activeLocalization, 'tip_continue_assessment', 'Continue Assessment'),
      manageProfile: localizeToString(this.props.activeLocalization, 'tip_manage_profile', 'Manage Profile'),
      backToApp: localizeToString(this.props.activeLocalization, 'tip_back_to_app', 'Back to App'),
      logout: localizeToString(this.props.activeLocalization, 'tip_logout', 'Logout'),
    }

    return (
      <ul className="navigation">
        {this.languageOptions() && this.languageOptions().length > 1 && this.renderLanguageSelectButton()}

        {!userIsOrganizationMember &&
          <li>
            <NavLink data-for="header-icon-assessment" data-tip={hasScoredAssessment ? localizations.viewResults : localizations.continueAssessment} to={`/a/${currentAssessmentConfig.assessmentName}?profile=${currentAssessmentConfig.profileName}`}>{getIcon('talents')}</NavLink>
            <ReactTooltip id="header-icon-assessment" effect="solid" place="bottom" />
          </li>
        }
        {!userIsOrganizationMember &&
          <li>
            <NavLink data-for="header-icon-assessment-profile" data-tip={localizations.manageProfile} to="/a/profile">{getIcon('profile')}</NavLink>
            <ReactTooltip id="header-icon-assessment-profile" effect="solid" place="bottom" />
          </li>
        }
        {userIsOrganizationMember &&
          <li>
            <NavLink data-for="header-icon-assessment-profile" data-tip={localizations.backToApp} to="/strengths">{getIcon('home')}</NavLink>
            <ReactTooltip id="header-icon-assessment-profile" effect="solid" place="bottom" />
          </li>
        }
        <li>
          <NavLink data-for="header-icon-assessment-logout" data-tip={localizations.logout} to={`/logout?continueUrl=${encodeURIComponent(appConfig().APP_URL)}/a/${currentAssessmentConfig.assessmentName}?profile=${currentAssessmentConfig.profileName}`}>{getIcon('logout')}</NavLink>
          <ReactTooltip id="header-icon-assessment-logout" effect="solid" place="bottom" />
        </li>
      </ul>
    );
  }

  renderNavigation(){

    if(this.showAssessmentHeader()){
      //probably want logout & settings page here...
      return this.renderAssessmentNavigation();
    }

    const userRole = currentUserRole();
    const showMinimalHeader = this.showMinimalHeader();

    if(!userRole){
      return null;
    }

    return (
      <ul className="navigation">

        {!showMinimalHeader && (userRole === 'admin' || userRole === 'superadmin') &&
          <li><NavLink to="/people">People</NavLink></li>
        }
        {!showMinimalHeader && userRole === 'manager' &&
          <li><NavLink to="/teams">My Team</NavLink></li>
        }
        {!showMinimalHeader && (userRole === 'manager' || userRole === 'salesleader' || userRole === 'admin' || userRole === 'superadmin') &&
          <li><NavLink to="/deals">Deals</NavLink></li>
        }
        {!showMinimalHeader && userRole === 'manager' &&
          <li><NavLink to="/imperatives">My Profile</NavLink></li>
        }
        {!showMinimalHeader && userRole === 'superadmin' &&
          <li><NavLink to="/assessments">assessments</NavLink></li>
        }
        {!showMinimalHeader && userRole !== 'manager' &&
          <li><NavLink to="/all-teams">Teams</NavLink></li>
        }
        {!showMinimalHeader && (userRole !== 'admin' && userRole !== 'salesleader' && userRole !== 'superadmin') &&
          <li><NavLink to="/resources">Resources</NavLink></li>
        }
        {!showMinimalHeader && userRole === 'salesleader' &&
          <li><NavLink to="/imperatives">My Profile</NavLink></li>
        }
        {!showMinimalHeader && (userRole === 'salesleader' || userRole === 'admin' || userRole === 'superadmin') &&
          <li><NavLink to="/reports">Reports</NavLink></li>
        }
        {/*disabled for now */}
        {!showMinimalHeader && (userRole === 'salesleader' || userRole === 'admin' || userRole === 'superadmin') && false &&
          <li><NavLink to="/insights">Insights</NavLink></li>
        }

        {!showMinimalHeader && (/*userRole === 'admin' || */userRole === 'superadmin') &&
          <li>
            <NavLink data-for="header-icon-admin-settings" data-tip="Organization Settings" to="/settings/general">{getIcon('settings')}</NavLink>
            <ReactTooltip id="header-icon-admin-settings" effect="solid" place="bottom" />
          </li>
        }
        {!showMinimalHeader && userRole === 'manager' &&
          <li>
            <NavLink data-for="header-icon-admin-profile" data-tip="Manage Profile" to="/profile">{getIcon('settings')}</NavLink>
            <ReactTooltip id="header-icon-admin-profile" effect="solid" place="bottom" />
          </li>
        }

        {!showMinimalHeader && userRole === 'superadmin' &&
          <li>
            <NavLink data-for="header-icon-admin-tooltip" data-tip="App Configuration" to="/admin/general">{getIcon('tools')}</NavLink>
            <ReactTooltip id="header-icon-admin-tooltip" effect="solid" place="bottom" />
          </li>
        }

        {!showMinimalHeader && userRole === 'superadmin' &&
          <li>
            <NavLink data-for="header-icon-admin-export" data-tip="Export Data & Reports" to="/adminexport">{getIcon('talents')}</NavLink>
            <ReactTooltip id="header-icon-admin-export" effect="solid" place="bottom" />
          </li>
        }

        <li>
          <NavLink data-for="header-icon-admin-logout" data-tip="Logout" to="/logout">{getIcon('logout')}</NavLink>
          <ReactTooltip id="header-icon-admin-logout" effect="solid" place="bottom" />
        </li>

      </ul>
    )
  }

  renderHeaderLogo(){
    const userRole = currentUserRole();

    const linkForHeader = (this.showAssessmentHeader() ? '/a' :
                          (userRole === 'employee' ? '/sprint' :
                          (userRole === 'manager' ? '/teams' :
                          (userRole === 'salesleader' ? '/all-teams' :
                          (userRole === 'admin' ? '/people' :
                          (userRole === 'superadmin' ? '/organizations' :
                          '/'))))));

                          console.log('this.props.route: ', this.props.route);

    if(this.props.route === '/public/networkTest'){
      //public page, don't link to app
      return (
        <React.Fragment>
          <img className="logo desktop" src={logo} alt="Velocity" />
          <img className="logo mobile" src={logoMobile} alt="Velocity" />
        </React.Fragment>
      );
    }
    else if(this.props.assessmentConfig){
      //taking assessment - show assessment logo
      return (
        <React.Fragment>
          <img className="logo desktop" src={this.props.assessmentConfig.logo} alt="Velocity" />
          <img className="logo mobile" src={this.props.assessmentConfig.logo} alt="Velocity" />
        </React.Fragment>
      );
    }
    else{
      //anywhere else...show our logo
      return (
        <NavLink to={linkForHeader}>
          <img className="logo desktop" src={logo} alt="Velocity" />
          <img className="logo mobile" src={logoMobile} alt="Velocity" />
        </NavLink>
      );
    }
  }

  renderOrganizationsDropdownIfSuperAdmin(){
    const userRole = currentUserRole();

    if(userRole !== 'superadmin'){
      return null;
    }

    return (
      <div className="organization-dropdown">
        <NavLink to="/organizations"><span>Viewing: {(this.props.organization || {}).name}</span>{getIcon('organization')}</NavLink>
      </div>
    )
  }

  languageOptions(){
    const { assessmentConfig, orgConfig } = this.props;

    if(assessmentConfig){
      return assessmentConfig.languages || false;
    }
    else if(orgConfig){
      return orgConfig.languages || false;
    }
    else{
      return false;
    }
  }

  render(){
    const showMinimalHeader = this.showMinimalHeader();
    const { assessmentConfig } = this.props;

    // console.log('assessmentConfig: ', assessmentConfig);

    return (
      <header className={showMinimalHeader ? 'minimal' : ''}>
        <div className="content-wrapper">
          {this.renderHeaderLogo()}
          {this.renderOrganizationsDropdownIfSuperAdmin()}
          {this.renderNavigation()}
        </div>
        <ChangeLocalizationModal
          languages={assessmentConfig ? assessmentConfig.languages : false}
          visible={this.state.changingLocalization}
          hide={() => { this.setState({ changingLocalization: false }); }}
        />
      </header>
    )
  }
}

function mapStateToProps(state, ownProps){
  //https://github.com/reactjs/react-router-redux#how-do-i-access-router-state-in-a-container-component
  return {
    user: state.user,
    route: ownProps.location.pathname,
    organization: state.organization.data,
    activeLocalizationKey: state.activeLocalization.data ? state.activeLocalization.data._id : 'default',
    myAssessments: state.myAssessments.data,
    assessmentConfig: state.assessmentConfig.data,
    orgConfig: state.orgConfig.data,
    activeLocalization: state.activeLocalization.data,
  }
}

export default withRouter(connect(mapStateToProps, {})(Header));



// WEBPACK FOOTER //
// ./src/components/header/index.js